import { queryOptions, useMutation } from "@tanstack/react-query";
import {
    GetFuelRates,
    PostFormBidRates,
    PostFormRateHistory,
    PostUserFeedback,
} from "./rate-calculator.api";

export function GetFuelRatesQueryOptions() {
    return queryOptions({
        queryKey: ["fuel-rates"],
        queryFn: () => GetFuelRates(),
    });
}

// export function GetLoadedMilesQueryOptions({
//     originZipCode,
//     destinationZipCode,
// }: {
//     originZipCode: string;
//     destinationZipCode: string;
// }) {
//     return queryOptions({
//         queryKey: ["loaded-miles", { originZipCode, destinationZipCode }],
//         queryFn: () => GetLoadedMiles({ originZipCode, destinationZipCode }),
//     });
// }

export function usePostFormBidRates() {
    return useMutation({
        mutationFn: PostFormBidRates,
    });
}

export function usePostFormRateHistory() {
    return useMutation({
        mutationFn: PostFormRateHistory,
    });
}

export function usePostUserFeedbackData() {
    return useMutation({
        mutationFn: PostUserFeedback,
    });
}
